import React, { useRef, useState } from "react";
import classes from "./style.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import ModalDropdown from "../../../../component/ModalDropdown";
import Button from "../../../../component/Button";
import { useNavigate } from "react-router-dom";

const ViewLoyalties = (props) => {
  const {
    isOpen = false,
    closePopUp,
    handleSuccessModal,
    selectedMembership,
    id
  } = props;
  const { name = "", rewardDetails = "" } = selectedMembership || {};

  const descriptionList = rewardDetails
  const navigate = useNavigate();

  const onEdit = () => {
    handleSuccessModal();
    navigate(`?type=edit?id=${id}`);
  };

  return (
    <>
      <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
        <div className={`${classes.viewLoyaltyWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>{name}</div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.loyaltyContainer}`}>
            <div>
              <div className={classes.informationHeader}>Reward Details</div>
              <ul>
                {descriptionList.map((point, index) => (
                  <li key={index} className={classes.loyaltyList}>
                    {point.trim()}
                  </li> 
                ))}
              </ul>
            </div>
            <div className="flex justify-end">
              <Button
                text={"Edit"}
                className={`w-[100%] my-4`}
                smallBtn
                onClick={() => onEdit()}
              />
            </div>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default ViewLoyalties;
